import React from "react";
import { MdOutlineTableRows, MdShowChart } from "react-icons/md";
import { Mixpanel, MxE } from "../../utils/mixpanelWrapper";
import { StateSetter } from "../../utils/types";
import { IconToggleButton } from "../IconToggleButton/IconToggleButton";

interface GraphTableToggleButtonProps {
  graphView: boolean;
  setGraphView: StateSetter<boolean>;
  className?: string;
  widgetName: string;
  disabled?: boolean;
  design?: "primary" | "secondary";
}

export const GraphTableToggleButton: React.FC<GraphTableToggleButtonProps> = ({
  graphView,
  setGraphView,
  widgetName,
  className,
  disabled = false,
  design,
}) => {
  return (
    <IconToggleButton
      size="sm"
      options={[
        { key: "showTable", icon: <MdOutlineTableRows />, label: "table view" },
        { key: "showGraph", icon: <MdShowChart />, label: "graph view" },
      ]}
      selectedOption={graphView ? "showGraph" : "showTable"}
      onChange={() =>
        setGraphView(prev => {
          Mixpanel.track(MxE.GRAPH_OR_TABLE_CHANGE, {
            widget: widgetName || "unknown",
            option_selected: !prev ? "graph" : "table",
          });
          return !prev;
        })
      }
      className={className}
      disabled={disabled}
      design={design}
    />
  );
};
